import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { DtoFilterValues, IFilterItemDto } from '@common';
import { DtoSelfServiceFormData } from '../../../../core';
import { FormDataPipe, MarkdownPipe } from '../../../../shared';
import { ChipSelectorComponent } from '../chip-selector/chip-selector.component';

@Component({
  selector: 'app-preselection-step',
  imports: [ChipSelectorComponent, FormDataPipe, MatDividerModule, MarkdownPipe, MatButtonModule, MatStepperModule],
  templateUrl: './preselection-step.component.html',
  styleUrls: ['./preselection-step.component.scss', '../self-service-form.step.scss']
})
export class PreselectionStepComponent {
  //#region Component Inputs --------------------------------------------------
  @Input({ required: true }) formData!: DtoSelfServiceFormData;
  @Input({ required: true }) filterValues!: DtoFilterValues;
  @Input({ required: true }) initialValues!: DtoFilterValues;
  @Output() selectionChanged = new EventEmitter<DtoFilterValues>();
  //#endregion

  //#region UI-Triggers -------------------------------------------------------
  protected categoriesChanged(newSelection: Array<IFilterItemDto>): void {
    const eventData: DtoFilterValues = {
      categories: new Array(...newSelection),
      customers: new Array(...this.initialValues.customers),
      roles: new Array(...this.initialValues.roles),
      keywords: new Array(...this.initialValues.keywords)
    };
    this.selectionChanged.emit(eventData);
  }

  protected customersChanged(newSelection: Array<IFilterItemDto>): void {
    const eventData: DtoFilterValues = {
      categories: new Array(...this.initialValues.categories),
      customers: new Array(...newSelection),
      roles: new Array(...this.initialValues.roles),
      keywords: new Array(...this.initialValues.keywords)
    };
    this.selectionChanged.emit(eventData);
  }

  protected rolesChanged(newSelection: Array<IFilterItemDto>): void {
    const eventData: DtoFilterValues = {
      categories: new Array(...this.initialValues.categories),
      customers: new Array(...this.initialValues.customers),
      roles: new Array(...newSelection),
      keywords: new Array(...this.initialValues.keywords)
    };
    this.selectionChanged.emit(eventData);
  }

  protected keywordsChanged(newSelection: Array<IFilterItemDto>): void {
    const eventData: DtoFilterValues = {
      categories: new Array(...this.initialValues.categories),
      customers: new Array(...this.initialValues.customers),
      roles: new Array(...this.initialValues.roles),
      keywords: new Array(...newSelection)
    };
    this.selectionChanged.emit(eventData);
  }
  //#endregion
}
